import styles from './style.module.scss';
function CalendarWidget() {
    return (
        <div className={styles.bodyLoader}>
            <span className={styles.loader}></span>
        </div>
    );
}

export default CalendarWidget;
